<template>
  <div class="HubInputSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="HubInputSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="HubInputSettings-main lxn-pos-rel">
      <div class="HubInputSettings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{getType === 'internal' ? $store.getters.language.texts.HubInputSettings_title1 : getType === 'expansion1' ? $store.getters.language.texts.HubInputSettings_title2 : $store.getters.language.texts.HubInputSettings_title3}}
          </template>
          <template v-slot:body>
            <div class="HubInputSettings-wrapper-inputs lxn-margin-auto lxn-border-round">
              <div class="HubInputSettings-input-spacer">
              </div>
              <div class="lxn-w100 lxn-display-flex-center lxn-margin-bottom-10 lxn-gap15" v-for="(inp, index) in getInputs">
                <div class="lxn-w5 lxn-lineH-50px lxn-text-center">X{{index + 1}}</div>
                <div class="lxn-w50">
                  <customInput v-model="inp.name" bgColor="#FFFFFF" inputType="text">
                  </customInput>
                </div>
                <div class="lxn-w45">
                  <div class="lxn-w100 lxn-display-flex-center lxn-gap5 lxn-margin-top-5">
                    <div class="lxn-text lxn-text-fa lxn-dir-rtl lxn-align-right lxn-w30">
                      {{$store.getters.language.texts.HubInputSettings_nc}}
                    </div>
                    <SingleSwitch @switchClicked="toggleNormalState(inp)" :state="inp.normalState" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :mini="true" />
                    <div class="lxn-text lxn-text-fa lxn-dir-rtl lxn-align-left lxn-w30">
                      {{$store.getters.language.texts.HubInputSettings_no}}
                    </div>
                  </div>
                  <div class="lxn-w100 lxn-display-flex-center lxn-gap5 lxn-margin-top-5">
                    <div class="lxn-text lxn-text-fa lxn-dir-rtl lxn-align-right lxn-w30">
                      {{$store.getters.language.texts.HubInputSettings_momentary}}
                    </div>
                    <SingleSwitch @switchClicked="toggleTypeState(inp)" :state="inp.typeState" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :mini="true" />
                    <div class="lxn-text lxn-text-fa lxn-dir-rtl lxn-align-left lxn-w30">
                      {{$store.getters.language.texts.HubInputSettings_toggle}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="HubInputSettings-button lxn-margin-auto lxn-w100 " style="margin-top: 20px">
              <CustomButton @click="saveInputs" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
                {{$store.getters.language.texts.HubInputSettings_button}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomInput from "@/components/CustomInput";
import SingleSwitch from "@/components/SingleSwitch";
import * as CONFIGS from "@/statics/configs";
import NODES from "@/statics/devices/Nodes";

export default {
  name: 'HubInputSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    CustomInput,
    TitleBox,
    ButtonIcon,
    SingleSwitch,
  },
  data: function () {
    const node = this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);
    const length = (this.$route.params.type === 'internal')? 12: 8;
    const param_base_idx = (this.$route.params.type === 'expansion1')? 12: (this.$route.params.type === 'expansion2')? 20: 0;
    var inputs = Array.from({length: length}, (_, i) => {
      return (node.inputs[param_base_idx + i]? 
        node.inputs[param_base_idx + i]: 
        (() => {
          const x = NODES[2][`INPUT${param_base_idx + i + 1}`];
          return {
            type: x.TYPE,
            name: this.$store.getters.language.texts[x.NAME],
            icon: x.ICON,
            parameterId: x.PARAMETER_ID,
            settings: {
              inputType: 0,
              unitType: this.$route.params.type
            }
          };
        })()
      );
    });
    return {
      node: node,
      type: this.$route.params.type,
      activeBoxIndex: node.color,
      inputs: inputs.map(x => ({
        ...x,
        normalState: x.normalState === 'no' ? 'on' : 'off',
        typeState: x.typeState === 'toggle' ? 'on' : 'off',
      }))
    };
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    getType: function () {
      return this.type;
    },
    getInputs: function () {
      return this.inputs;
    },
  },
  methods: {
    toggleNormalState: function (inp) {
      if(inp.normalState === 'on'){
        inp.normalState = 'off';
      }else{
        inp.normalState = 'on';
      }
    },
    toggleTypeState: function (inp) {
      if(inp.typeState === 'on'){
        inp.typeState = 'off';
      }else{
        inp.typeState = 'on';
      }
    },
    goBack: function () {
      this.$router.push('/hubIOSettings/' + this.node.uuid + '/' + this.type);
    },
    saveInputs: function () {
      this.$store.commit('setHubInputs', {
        uuid: this.node.uuid,
        inputs: this.inputs.map((x, idx) => ({
          ...x,
          type: this.type,
          normalState: x.normalState === 'on' ? 'no' : 'nc',
          typeState: x.typeState === 'on' ? 'toggle' : 'momentary'
        }))
      });
      this.$store.commit('saveState');
      this.goBack();
    },
  }
}
</script>

<style>
.HubInputSettings-topCurve-wrapper {
  height: 200px;
}
.HubInputSettings-main {
  z-index: 2;
}
.HubInputSettings-main-wrapper {
  min-height: 150px;
  width: calc(100% - 36px);
  margin-top: -150px;
  background-color: #ffffff;
  margin-bottom: 14px;
  padding: 14px;
}
.HubInputSettings-wrapper-users {
  height: 50px;
  background-color: #FFFFFF;
  margin-top: 14px;
}
.HubInputSettings-wrapper-inputs {
  width: 100%;
  margin-bottom: 14px;
}
.HubInputSettings-input-spacer {
  height: 16px;
}
.HubInputSettings-button {
  width: 100%;
}
</style>
